<template>
<div>
     <div class="radio-group-device d-block">
         <nav>
        <div class="nav nav-tabs login-forms-part" id="nav-tab" role="tablist">
            <button v-on:click="screenChange('mobile')" class="nav-link active" id="nav-mobile-tab" data-bs-toggle="tab" data-bs-target="#nav-mobile" type="button" role="tab" aria-controls="nav-mobile" aria-selected="true"><i class="las la-mobile"></i>  Mobile</button>
            <button v-on:click="screenChange('email')" class="nav-link" id="nav-email-tab" data-bs-toggle="tab" data-bs-target="#nav-email" type="button" role="tab" aria-controls="nav-email" aria-selected="false"><i class="las la-envelope"></i> Email</button>
        </div>
        </nav>

 
     </div>
                    <form  id="login" method="POST" @submit.stop.prevent="login">


                        <div v-if="screenSwitch=='mobile-screen'" >
                            <div class="form-group mb-3">
                               <input type="hidden" name="task"  v-model="form.task"  />
                                <input id="request_value" v-model="form.request_value"
                                v-validate="'required'"  maxlength="10" data-vv-as="mobile"
                                class="form-control " name="request_value" value=""  placeholder="Please Enter Mobile ">
                                <span class="error">{{ veeErrors.first('request_value') }}</span>

                            </div>
                            <div class="form-group mb-0">
                                <div class="col-md-12 text-end">
                                    <button  type="submit" class="btn btn-primary submit_btn">Request Otp</button>
                                </div>
                            </div>
                        </div>

                         <div class="form-group row" v-if="screenSwitch=='mobile-otp'" >
                                <p class="px-0">We've sent an OTP on your phone number.
                                    <br/>
                                    (+91  *** *** {{ form.request_value.substr(6, 9) }}    )
                                </p>
                                <input type="hidden" name="task" v-model="form.task" />
                               <input class="form-control" type="text" name="otp" v-model="form.otp" data-vv-as="otp"
                               v-validate="'required|digits:6'"  maxlength="6"  placeholder="Enter OTP">
                                  <span class="error">{{ veeErrors.first('otp') }}</span>
                                <div class="col-md-12 text-end mt-4 p-0">
                                    <a  class="btn btn-outline-primary submit_btn" v-on:click="screenChange('mobile')">Back</a>
                                    <button  class="btn btn-outline-primary submit_btn" v-on:click="resend_otp">Resend OTP</button>
                                    <button type="submit" class="btn btn-primary submit_btn">Submit</button>
                                </div>
                        </div>

                        <div v-if="screenSwitch=='email-screen'">
                            <div class="form-group mb-3">
                               <input type="hidden" name="task"  v-model="form.task"  />
                                <input id="request_value" v-model="form.request_value"
                                v-validate="'required|email'"  data-vv-as="email"
                                class="form-control " name="request_value"  placeholder="Please Enter Email">
                                <span class="error">{{ veeErrors.first('request_value') }}</span>

                            </div>
                            <div class="form-group mb-0">
                                <div class="col-md-12 text-end">
                                    <button type="submit"  class="btn btn-primary submit_btn">Request Otp</button>
                                </div>
                            </div>
                        </div>

                         <div class="form-group row" v-if="screenSwitch=='email-otp'" >
                                <p class="px-0">We've sent an OTP on your email id.
                                    <br/>
                                     {{ protect_email(form.request_value) }}
                                </p>
                                <input type="hidden" name="task" v-model="form.task" />
                               <input class="form-control" type="text" name="otp" v-model="form.otp" data-vv-as="otp"
                               v-validate="'required|digits:6'"  maxlength="6"  placeholder="Enter OTP">
                                  <span class="error">{{ veeErrors.first('otp') }}</span>
                                <div class="col-md-12 text-end mt-4 p-0">
                                    <a  class="btn btn-outline-primary submit_btn" v-on:click="screenChange('email')">Back</a>
                                    <a  class="btn btn-outline-primary submit_btn" v-on:click="resend_otp">Resend OTP</a>
                                    <button type="submit" class="btn btn-primary submit_btn">Submit</button>
                                </div>
                        </div>

                     </form>
</div>

</template>

<script>

export default {
  name: "DsaLogin",
  components: {

  },
  data() {
    return {
      screenSwitch:'mobile-screen',
      states: [],
      form: {
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        request_value: "",
        otp:"",
        type:"mobile",
        task:'requestOtp',
      },
      allerros: [],
      success : false,
    };
  },
  created() {

  },
  methods: {
      login(e){



            this.$validator.validateAll().then((result) => {
                if (!result) {
                    const el = document.querySelector(".is-invalid");
                        el.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });

                }else{

                    if(this.form.task=='requestOtp'){
                        axios.post("/request-otp", {
                                type:(this.screenSwitch=='mobile-screen')?'mobile':'email',
                                subject:'customer-login',
                                type_value:this.form.request_value
                            }).then((response) => {
                            // response.data;
                            if(response.data.status){
                                    if(this.screenSwitch=='mobile-screen'){
                                        this.screenSwitch='mobile-otp';
                                        this.type='mobile';
                                    }
                                    if(this.screenSwitch=='email-screen'){
                                        this.screenSwitch='email-otp';
                                        this.type='email';
                                    }
                                    this.form.task='verifyOtp';
                            }else{

                                Swal.fire({
                                    icon: 'error',
                                    title: 'Oops...',
                                    text: response.data.message
                                });
                            }

                            })
                            .catch((error) => {
                            // handle error
                            console.log(error);
                        });
                    e.preventDefault();

                    }
                    if(this.form.task=='verifyOtp'){
                        this.verifyOtp(e);
                    }
                }
            });
         e.preventDefault();
      },screenChange(e){

          if(e=='mobile'){
             this.screenSwitch='mobile-screen';
             this.form.request_value='';
             this.form.task="requestOtp";
          }
          if(e=='email'){
             this.screenSwitch='email-screen';
             this.form.request_value='';
             this.form.task="requestOtp";
          }
          this.request_value='';
      },
    requestOtp(e) {

    },   validate() {
        return new Promise((resolve, reject) => {
            if (this.model.addRawData == undefined && this.model.locations) {
              this.checkSelected('map')
            }

            this.$validator.validate().then((result) => {
              if (!result) {
                reject(reject)
                return
              }

              if(this.model.verified !== undefined) {
                if(!this.model.verified && this.model.verified == null) {

                    reject(reject)
                    return
                }
              }
              this.$emit('on-validate', result, this.model)
              resolve(resolve)
            })
        })
    },
     resend_otp(){
       axios.post("/request-otp", {
                                  type:this.type,
                                  subject:'customer-login',
                                  type_value:this.form.request_value,

                      }).then((response) => {
                              // response.data;
                              if(response.data.status)
                              {
                                Swal.fire('OTP resend successfully.');

                              }else{
                                Swal.fire('Too Many Attampts.');

                              }
                           
                      })
                      .catch((error) => {
                      // handle error
                      console.log(error);
                      });
        e.preventDefault();
    },
   isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
         return true;
      }
    },protect_email:function(user_email){
        var avg, splitted, part1, part2;
        splitted = user_email.split("@");
        part1 = splitted[0];
        avg = part1.length / 2;
        part1 = part1.substring(0, (part1.length - avg));
        part2 = splitted[1];
        return part1 + "***@" + part2;
    },
    verifyOtp: function() {
            axios.post("/customer/login", {
                    type:this.type,
                    subject:'customer-login',
                    type_value:this.form.request_value,
                    otp:this.form.otp,
                }
            ).then((response) => {
                if(response.data.status){
                    window.location.href = "/customer";
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: response.data.message
                    });
                }
            }).catch((error) => {
                 console.log(error);
            });
    }
  },
};

</script>

